module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_location_kyodomura-9c1c11a1a3947eb3d5ec535670cc8e53.jpg";